module.exports = __webpack_public_path__ + "img/arrow.37d46999.svg";